import styled from 'styled-components';
import device from '../../../../GlobalDigitalStyle/BreakPoint.style';

export const TournamentStandingContainer = styled.div`
	.home__headers {
		font-weight: 700;
		font-size: 15px;
		@media ${device.screen1680} {
			font-size: 14px;
		}
		@media ${device.screen1280} {
			font-size: 12.8px;
		}
		@media ${device.screen1050} {
			font-size: 11px;
		}
		.header__toggle__tab {
			padding: 1.5em 1rem;
			@media ${device.screen1440} {
				padding: 1.5em 1rem;
			}
			@media ${device.screen1366} {
				padding: 1.5em 1rem;
			}
			@media ${device.screen1050} {
			}
		}
		.standing__table_container {
			height: 20em;
			.standing__table {
				height: 20em;
				.standings__cell {
				}
			}
		}
	}
	.standing__table_container {
		height: 20em;
	}

	.text__default {
		font-weight: 600;
		font-size: 15px;
		@media ${device.screen1680} {
			font-size: 14px;
		}
		@media ${device.screen1280} {
			font-size: 12.8px;
		}
		@media ${device.screen1050} {
			font-size: 11px;
		}
	}
`;
